import axios from "axios";

const baseURL = "https://viacep.com.br/ws/";

const baseAPI = axios.create({
  baseURL,
  timeout: 20000,
})

export default baseAPI; 